import moment from 'moment-timezone';
import { v4 as uuidv4 } from 'uuid';
import getHelpAndSupport from './mapping/supportData'

const timezone = 'Pacific/Auckland' 

const { sunnyInitialMessage, ...helpAndSupport } = getHelpAndSupport()

export default function defaultState(): any {
    return {
        ...helpAndSupport,
        directDebit: {},
        rightPanel: null,
        acctSelected: 'details',
        chat: {
          asking: false,
          chatWindow: 10,
          threadId: uuidv4(),
          messages: {
            '0':  {
              from: 'sunny',
              timeMs: 0,
              message: sunnyInitialMessage
            }
          }
        },
        monitorSelected: {
          home: 'value1',
          solar: 'value1'
        },
        filter: {
          from: moment.tz(moment(), timezone).startOf('day').format(),
          to: moment.tz(moment(), timezone ).endOf('day').format(),
          interval: 'hour'
        },
        reportSelected: 'home',    
      } 
}